import { render, staticRenderFns } from "./AffectItemNew.vue?vue&type=template&id=53526ec7"
import script from "./AffectItemNew.vue?vue&type=script&lang=js"
export * from "./AffectItemNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports